/* ──────────────────────────────────────────────────────────────────────────
 * OPP series: Runtime operation errors
 * ────────────────────────────────────────────────────────────────────────── */
export const OPERATION_ERROR_CODES = {
  TENANT_SET_FAILED: 'CLIENTOS_OPP_001',
  CONSENT_INIT_FAILED: 'CLIENTOS_OPP_002',
  TENANT_LEVEL_VALIDATION_FAILED: 'CLIENTOS_OPP_003'
} as const;
